import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  isMobileOrTabletDevice,
  IS_DISPLAY_IN_NEW_TAB_PARAM,
} from "@lhd/utility";
import { ROUTES } from "@lhd/constants";

// Routes that end "new tab" mode: landing here clears the saved flag so the
// URL stays clean instead of getting isDisplayInNewTab re-attached.
const EXIT_NEW_TAB_MODE_ROUTES = [`/${ROUTES.BUSINESS_RPG}`];

const PreserveQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isReplacing = useRef(false);
  const isExitNewTabModeRoute = EXIT_NEW_TAB_MODE_ROUTES.includes(
    location.pathname,
  );

  useEffect(() => {
    if (location.pathname === `/${ROUTES.PASSWORD_RESET}`) return;

    const params = new URLSearchParams(location.search);
    const value = params.get(IS_DISPLAY_IN_NEW_TAB_PARAM);

    if (isMobileOrTabletDevice() || isExitNewTabModeRoute) {
      sessionStorage.removeItem(IS_DISPLAY_IN_NEW_TAB_PARAM);
      return;
    }

    if (value) {
      sessionStorage.setItem(IS_DISPLAY_IN_NEW_TAB_PARAM, value);
    }
  }, [location.pathname, location.search, isExitNewTabModeRoute]);

  useEffect(() => {
    if (location.pathname === `/${ROUTES.PASSWORD_RESET}`) return;

    if (isReplacing.current) {
      isReplacing.current = false;
      return;
    }

    const params = new URLSearchParams(location.search);

    if (isMobileOrTabletDevice() || isExitNewTabModeRoute) {
      if (!params.get(IS_DISPLAY_IN_NEW_TAB_PARAM)) return;

      params.delete(IS_DISPLAY_IN_NEW_TAB_PARAM);
      const nextSearch = params.toString();
      isReplacing.current = true;
      navigate(
        nextSearch ? `${location.pathname}?${nextSearch}` : location.pathname,
        { replace: true },
      );
      return;
    }

    const saved = sessionStorage.getItem(IS_DISPLAY_IN_NEW_TAB_PARAM);

    if (!saved) return;

    if (params.get(IS_DISPLAY_IN_NEW_TAB_PARAM)) return;

    params.set(IS_DISPLAY_IN_NEW_TAB_PARAM, saved);

    isReplacing.current = true;

    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true,
    });
  }, [location.pathname, location.search, navigate, isExitNewTabModeRoute]);

  return null;
};

export default PreserveQueryParams;
